<!--
 * @Author: 范向玲
 * @Date: 2022-12-20 17:36:14
 * @LastEditors: 范向玲
 * @LastEditTime: 2022-12-20 17:36:14
 * @Description: 文件上传
 * @FilePath: \src\components\lib\Upload\fileUpload.vue
-->
<template>
  <section class="file-upload-container">
    <a-upload
      v-model:file-list="optionConf.fileList"
      name="file"
      :accept="uploadType"
      :showUploadList="true"
      @change="handleChange"
      :before-upload="beforeUpload"
    >
      <a-button>文件上传</a-button>
    </a-upload>
  </section>
</template>

<script setup>
import { ref, reactive, defineEmits, toRefs, defineProps, onMounted, onBeforeMount, } from 'vue';

defineProps({
  uploadType: {
    type: String,
  },
});

// emit
const emit = defineEmits(['fileList',]);

const optionConf = reactive({
  fileList: [],
});

/**
 * @description 阻止选择文件自动上传
 */
const beforeUpload = (file) => {
  return false;
};
/**
 * @description 导入文件修改
 */
const handleChange = (info) => {
  optionConf.fileList = [...info.fileList,];
  // optionConf.fileList = [info.file,];
  optionConf.fileList = optionConf.fileList.map(file => {
    if (file.response && file.response.data) {
      file.url = file.response.data.absolute_path;
    } else if (file.response && file.response.code !== 200 && file.response.errors.length > 0) {
      file.status = 'error';
      file.name = file.response.errors[0];
    } else if (file.status === 'error') {
      file.name = '[上传失败]';
    }
    return file;
  });
  emit('fileList', optionConf.fileList);
};

</script>

<style lang="scss">
.file-upload-container {
  .ant-upload-list-item-name {
    padding-left: 0;
    color: #fff;
  }
  // 文件列表悬浮样式修改
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    background-color: rgba(140, 100, 30, .4);
  }
  .ant-upload-list-item-card-actions .anticon {
    color: #fff;
  }
  .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
    color: red;
  }
}
</style>